export enum Action {
    RemoveCentral = '- X X -',
    RemoveSet = 'X X X X',
    Pass = '- - - -'
}
